import { render, staticRenderFns } from "./FlexBoxWorkouts.vue?vue&type=template&id=484ccaba&scoped=true&"
import script from "./FlexBoxWorkouts.vue?vue&type=script&lang=js&"
export * from "./FlexBoxWorkouts.vue?vue&type=script&lang=js&"
import style0 from "./FlexBoxWorkouts.vue?vue&type=style&index=0&id=484ccaba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ccaba",
  null
  
)

export default component.exports